var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIconBorder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.938,
    height: 45,
    viewBox: "0 0 45.938 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5523",
    "data-name": "Grupo 5523",
    transform: "translate(-3154 -1516)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_536",
    "data-name": "Caminho 536",
    d: "M22.969,0A22.738,22.738,0,0,1,45.938,22.5,22.738,22.738,0,0,1,22.969,45,22.738,22.738,0,0,1,0,22.5,22.738,22.738,0,0,1,22.969,0Z",
    transform: "translate(3154 1516)",
    fill: "#fee2e2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_5280",
    "data-name": "Grupo 5280",
    transform: "translate(3159 1521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3740",
    "data-name": "Caminho 3740",
    d: "M0,0H35.239V35.239H0Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_3741",
    "data-name": "Caminho 3741",
    d: "M18.559,3H9.441L3,9.441v9.118L9.441,25h9.118L25,18.559V9.441Zm4,14.544-5.011,5.011H10.456L5.444,17.544V10.456l5.011-5.011h7.089l5.011,5.011Zm-5.1-8.727L14,12.277,10.541,8.818,8.818,10.541,12.277,14,8.818,17.459l1.723,1.723L14,15.723l3.459,3.459,1.723-1.723L15.723,14l3.459-3.459L17.459,8.818Z",
    transform: "translate(4 4)",
    fill: "#ff0027",
    stroke: "#000",
    strokeWidth: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconBorder);
export default __webpack_public_path__ + "static/media/delete-icon-border.8dfba57df8badb91ce281dd0c335649f.svg";
export { ForwardRef as ReactComponent };